import { NgModule, SkipSelf, Optional } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ProcessingService } from './processing.service';
import { BookingResourceModule } from 'libraries/service/resources/booking/bookingResource.module';
import { ProcessingResourceModule } from 'app_sasha/shared/resources/processings/processingResource.module';

@NgModule({
    imports: [
        BookingResourceModule,
        ProcessingResourceModule,
        RouterModule,
    ],
    declarations: [],
    exports: [],
    providers: [
        ProcessingService
    ],
})
export class ProcessingModule {
    // https://angular.io/guide/singleton-services
    // this allows to declare this service as a pure singleton even when
    // used in lazy-loaded routes
    public constructor(@SkipSelf() @Optional() parentModule: ProcessingModule) {
        if (parentModule) {
            throw new Error("ProcessingModule must only be imported once in sasha main Module");
        }
    }
}